import { render, staticRenderFns } from "./HeaderReport.vue?vue&type=template&id=0dc72613&functional=true"
import script from "./HeaderReport.vue?vue&type=script&lang=js"
export * from "./HeaderReport.vue?vue&type=script&lang=js"
import style0 from "./HeaderReport.vue?vue&type=style&index=0&id=0dc72613&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports